// Fork JavaMifi: CRUD organisasi (BU) untuk administrator.
import ApiClient from './ApiClient';

class OrganizationsAPI extends ApiClient {
  constructor() {
    super('organizations', { accountScoped: true });
  }
}

export default new OrganizationsAPI();
